import { of } from "rxjs";
import { EventEmitter } from "@angular/core";
import { IssueSubmissionResponse, PolicyChangeQuoteResponse } from '../../models';
var PolicyChangeServiceStub = /** @class */ (function () {
    function PolicyChangeServiceStub() {
        this.isOpen = new EventEmitter();
    }
    PolicyChangeServiceStub.prototype.setCarChange = function () {
        return of();
    };
    PolicyChangeServiceStub.prototype.createPolicyChange = function () {
        return of();
    };
    PolicyChangeServiceStub.prototype.policyChangeQuote = function () {
        return of(new PolicyChangeQuoteResponse());
    };
    PolicyChangeServiceStub.prototype.issueSubmission = function () {
        return of(new IssueSubmissionResponse());
    };
    return PolicyChangeServiceStub;
}());
export { PolicyChangeServiceStub };
